import React, { Component } from 'react';
import { find, isEqual } from 'lodash';
import ReactMapboxGl, {
  Layer,
  Feature,
  Popup,
  ZoomControl
} from 'react-mapbox-gl';
import { LngLatBounds } from 'mapbox-gl';
import LocatorResultDetails from './LocatorResultDetails';
import { maxZoom, padding, popupOffset } from '../../../config/mapConfig';
import { MAPBOX_API_KEY } from '../../../config';

const generateBounds = (places) => {
  if (!places.length) {
    return null;
  }

  const bounds = new LngLatBounds();
  places.forEach((place) => {
    bounds.extend(place.location);
  });

  return [
    [bounds._ne.lng, bounds._ne.lat],
    [bounds._sw.lng, bounds._sw.lat]
  ];
};

const Map = ReactMapboxGl({
  accessToken: MAPBOX_API_KEY,
  scrollZoom: false
});

class LocatorMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bounds: null,
      center: [-96.0622833, 36.7936704],
      prevPropsCurrentPlace: props.currentPlace,
      placesById: [],
      zoom: [3]
    };
  }

  static getDerivedStateFromProps(props, state) {
    const placesById = props.places.map((place) => place.id);
    if (!isEqual(state.placesById, placesById)) {
      return {
        bounds: generateBounds(props.places),
        placesById
      };
    } else if (
      state.prevPropsCurrentPlace !== props.currentPlace &&
      props.currentPlace !== null
    ) {
      if (props.currentPlace === null) {
        return {
          prevPropsCurrentPlace: props.currentPlace
        };
      }
      const selectedPlace = find(
        props.places,
        (place) => place.id === props.currentPlace
      );
      return {
        center: [selectedPlace.location[0], selectedPlace.location[1]],
        prevPropsCurrentPlace: props.currentPlace
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(this.props, nextProps)) {
      return false;
    }
    return true;
  }

  render() {
    const { currentPlace, places, setCurrentPlace } = this.props;
    const { bounds, center, zoom } = this.state;
    const selectedPlace = find(places, (place) => place.id === currentPlace);

    return (
      <Map
        center={center}
        fitBounds={bounds}
        fitBoundsOptions={{ maxZoom, padding }}
        style="mapbox://styles/propanecouncil/cjoovbm9c46f42qntb8o5itlq"
        zoom={zoom}
      >
        <ZoomControl />
        <Layer
          type="symbol"
          layout={{
            'icon-image': 'marker-11',
            'icon-allow-overlap': true
          }}
          paint={{
            'icon-color': '#00ff00'
          }}
        >
          {places.map((place) => (
            <Feature
              key={place.id}
              coordinates={place.location}
              onClick={() => setCurrentPlace(place.id)}
            />
          ))}
        </Layer>
        {selectedPlace && (
          <Popup coordinates={selectedPlace.location} offset={popupOffset}>
            <div className="map__popup">
              <LocatorResultDetails
                place={selectedPlace}
                includeDistance={false}
              />
            </div>
          </Popup>
        )}
      </Map>
    );
  }
}

export default LocatorMap;
